import * as R from 'ramda';
import MoneyRendererV3 from '../../../../../components/Money/MoneyRendererV3/MoneyRendererV3';
import PriceCompositionMarker from '../../../../../components/Money/PriceCompositionMarker';
import Typography from '../../../../../components/v2/ui/Typography/Typography';
import { useModalState } from '../../../../../hooks/useModalState';
import ProductPricesTooltip from '../../components/ProductPricesTooltip';
import useWholesalePriceSection from '../hooks/useWholesalePriceSection';
import { WholesalePriceSectionProps } from '../interfaces/wholesalePriceSection.interfaces';

export const WholesalePriceSection = ({
  prices,
  minMaxWholesale,
  showInfoTooltip,
}: WholesalePriceSectionProps) => {
  const { isOpen, openModal, closeModal } = useModalState();
  const {
    tooltipPrices,
    minNetPriceToShow,
    maxNetPriceToShow,
    minGrossPriceToShow,
    maxGrossPriceToShow,
  } = useWholesalePriceSection({ prices });

  const showPricesVariation =
    minNetPriceToShow !== maxNetPriceToShow || minGrossPriceToShow !== maxGrossPriceToShow;

  return (
    <ProductPricesTooltip
      isModalOpen={isOpen}
      prices={tooltipPrices}
      open={showInfoTooltip}
      closeModal={closeModal}
      hasPriceVariation={showPricesVariation}
    >
      <PriceCompositionMarker isActive={showInfoTooltip} onClick={openModal}>
        {showPricesVariation && (
          <>
            <MoneyRendererV3
              color="textPrimary"
              promotionValue={minNetPriceToShow}
              value={minGrossPriceToShow || minMaxWholesale?.min!}
              size="large"
            />
            <Typography variant="body1" color="text.primary">
              -
            </Typography>
          </>
        )}
        {!R.isNil(minMaxWholesale?.max) && (
          <MoneyRendererV3
            color="textPrimary"
            promotionValue={maxNetPriceToShow}
            size="large"
            value={maxGrossPriceToShow || minMaxWholesale?.max}
          />
        )}
      </PriceCompositionMarker>
    </ProductPricesTooltip>
  );
};

export default WholesalePriceSection;
